import { ArrowRight, Check } from 'lucide-react';
import type { Locale } from '@/lib/content';

const labels: Record<string, { heading: string; description: string; cta: string; noCc: string; instant: string; trial: string }> = {
  nl: { heading: 'Meer functies nodig?', description: 'Maak een gratis account aan en krijg toegang tot automatische facturatie, UBL export en meer.', cta: 'Gratis Account Aanmaken', noCc: 'Geen creditcard nodig', instant: 'Direct starten', trial: 'Gratis proefperiode' },
  en: { heading: 'Need more features?', description: 'Create a free account and get access to automatic invoicing, UBL export and more.', cta: 'Create Free Account', noCc: 'No credit card required', instant: 'Start immediately', trial: 'Free trial' },
  de: { heading: 'Mehr Funktionen benötigt?', description: 'Erstellen Sie ein kostenloses Konto und erhalten Sie Zugang zu automatischer Rechnungsstellung, UBL-Export und mehr.', cta: 'Kostenloses Konto erstellen', noCc: 'Keine Kreditkarte erforderlich', instant: 'Sofort starten', trial: 'Kostenlose Testversion' },
  fr: { heading: 'Besoin de plus de fonctionnalités ?', description: "Créez un compte gratuit et accédez à la facturation automatique, l'export UBL et plus encore.", cta: 'Créer un compte gratuit', noCc: 'Pas de carte de crédit requise', instant: 'Commencer immédiatement', trial: 'Essai gratuit' },
};

interface ToolSignupWallProps {
  locale: Locale;
}

export function ToolSignupWall({ locale }: ToolSignupWallProps) {
  const l = labels[locale] || labels.nl;

  return (
    <div className="rounded-2xl border-2 border-[rgba(244,115,14,0.1)] bg-gradient-to-b from-transparent to-[#f8faff] p-10 text-center mt-8">
      <h3 className="text-2xl font-bold text-navy mb-2">{l.heading}</h3>
      <p className="text-slate-600 text-sm mb-5 max-w-md mx-auto">{l.description}</p>
      <a
        href={`/${locale}/signup/`}
        className="inline-flex items-center gap-2 bg-gradient-cta text-ink px-8 py-4 rounded-xl font-bold text-lg shadow-[0_8px_20px_rgba(244,115,14,0.3)] hover:scale-[1.03] transition-transform"
        data-track="Tool Signup Wall"
        data-track-category="CTA"
      >
        {l.cta}
        <ArrowRight className="h-5 w-5" />
      </a>
      <div className="flex flex-wrap gap-4 justify-center mt-4 text-xs text-slate-500">
        <span className="flex items-center gap-1"><Check className="h-3.5 w-3.5 text-trust-green" /> {l.noCc}</span>
        <span className="flex items-center gap-1"><Check className="h-3.5 w-3.5 text-trust-green" /> {l.instant}</span>
        <span className="flex items-center gap-1"><Check className="h-3.5 w-3.5 text-trust-green" /> {l.trial}</span>
      </div>
    </div>
  );
}
